import router from "./router-config";
import store from "./store";
import axios from "axios";

function isFamilyLoggedIn() {
    return (
        sessionStorage.getItem("familyIsLogin") === "true" &&
        !!sessionStorage.getItem("familyUser") &&
        !!sessionStorage.getItem("familyToken")
    );
}

function clearFamilySession() {
    sessionStorage.removeItem("familyIsLogin");
    sessionStorage.removeItem("familyToken");
    sessionStorage.removeItem("familyUser");
}

function isFamilyTokenNotExpired() {
    const token = sessionStorage.getItem("familyToken");
    if (!token) return false;
    try {
        const parts = token.split(".");
        if (parts.length !== 3) return false;
        const payload = JSON.parse(atob(parts[1]));
        const now = Math.floor(Date.now() / 1000);
        return !(payload && payload.exp && Number(payload.exp) < now);
    } catch (e) {
        return false;
    }
}

async function verifyFamilySessionWithServer() {
    const token = sessionStorage.getItem("familyToken");
    if (!token) return false;
    try {
        const res = await axios.get("/web/family/order/list", {
            headers: { Authorization: token },
            timeout: 8000,
            params: { _t: Date.now() },
        });
        const body = res && res.data;
        const code = Number(body && body.code);
        if (body && (body.success || code === 1)) return true;
        if (code === 9006 || code === 401 || code === 403) return false;
        return true;
    } catch (error) {
        const status = error && error.response && error.response.status;
        const dataCode = Number(error && error.response && error.response.data && error.response.data.code);
        if (status === 401 || status === 403 || dataCode === 9006) {
            return false;
        }
        return true;
    }
}

// 检查token是否有效
function checkTokenValidity() {
    const token = store.state.token;
    const isLogin = store.state.isLogin;
    
    console.log('检查token有效性:', { hasToken: !!token, isLogin });
    
    if (!isLogin || !token) {
        return false;
    }
    
    try {
        // 检查token格式（JWT格式：header.payload.signature）
        const tokenParts = token.split('.');
        if (tokenParts.length !== 3) {
            console.log('Token格式错误');
            return false;
        }
        
        // 解析JWT payload
        const payload = JSON.parse(atob(tokenParts[1]));
        const currentTime = Math.floor(Date.now() / 1000);
        
        console.log('Token检查:', { 
            exp: payload.exp, 
            currentTime, 
            expired: payload.exp ? payload.exp < currentTime : 'no exp field' 
        });
        
        // 检查token是否过期
        if (payload.exp && payload.exp < currentTime) {
            console.log('Token已过期');
            return false;
        }
        
        return true;
    } catch (error) {
        console.log('Token解析失败:', error.message);
        return false;
    }
}

router.beforeEach(async (to, from, next) => {
    console.log('路由守卫:', to.path, from.path, '登录状态:', store.state.isLogin);
    
    // 门户入口、登录/注册页无需认证
    if (
        to.path === '/portal' ||
        to.path === '/login' ||
        to.path === '/register' ||
        to.path === '/family/login' ||
        to.path === '/family/register' ||
        to.path === '/caregiver'
    ) {
        if (to.path === '/login') {
            if (checkTokenValidity()) {
                console.log('Token有效，跳转到首页');
                next('/dispatch/orders');
                return;
            }
            if (store.state.isLogin) {
                store.commit('setLoginOut');
            }
        }
        if ((to.path === '/family/login' || to.path === '/family/register') && isFamilyLoggedIn()) {
            next('/family');
            return;
        }
        next();
        return;
    }

    // 家属端功能页需登录（/family 首页允许匿名访问）
    if (to.meta.familyAuth) {
        if (!isFamilyLoggedIn() || !isFamilyTokenNotExpired()) {
            clearFamilySession();
            next({
                path: '/family/login',
                query: { redirect: to.fullPath },
            });
            return;
        }
        const validOnServer = await verifyFamilySessionWithServer();
        if (!validOnServer) {
            clearFamilySession();
            next({
                path: '/family/login',
                query: { redirect: to.fullPath },
            });
            return;
        }
        next();
        return;
    }
    
    // 检查是否需要认证的页面
    if (to.meta.requireAuth !== false) {
        // 检查token有效性
        if (!checkTokenValidity()) {
            console.log('Token无效或过期，跳转到登录页');
            store.commit('setLoginOut');
            next({
                path: '/login',
                query: { redirect: to.fullPath }
            });
            return;
        }
    }
    
    next();
});
